import { api } from "./api";

export const messList = async (addUrl = "") => {
  return await api.get(`/mess/list?${addUrl}`);
};

export const messAdd = async (data) => {
  return await api.post(`/mess/add`, data);
};

export const messUpdate = async (data) => {
  return await api.post(`/mess/update`, data);
};

export const messDelete = async (id) => {
  return await api.post(`/mess/delete`, { id });
};

export const messStatusChange = async (id) => {
  return await api.post(`/mess/status/change`, { id });
};

export const messEnrollList = async (addUrl = "") => {
  return await api.get(`/mess/enroll/list?${addUrl}`);
};

export const messEnroll = async (data) => {
  return await api.post(`/mess/enroll`, data);
};

export const messEnrollUpdate = async (data) => {
  return await api.post(`/mess/enroll/update`, data);
};

export const messEnrollDelete = async (id) => {
  return await api.post(`/mess/enroll/delete`, { id });
};

export const messEnrollStatusChange = async (data) => {
  return await api.post(`/mess/enroll/status/change`, data);
};

export const messAttendanceSheet = async (data) => {
  return await api.post(`/mess/attendance/sheet`, data);
};

export const messMarkAttendance = async (data) => {
  return await api.post(`/mess/attendance/mark`, data);
};

export const messAttendanceCheckout = async (data) => {
  return await api.post(`/mess/attendance/checkout`, data);
};

export const messAttendanceList = async (addUrl = "") => {
  return await api.get(`/mess/attendance/list?${addUrl}`);
};

export const messAttendanceDelete = async (id) => {
  return await api.post(`/mess/attendance/delete`, { id });
};

export const messAttendanceMonthlyCalendar = async (data) => {
  return await api.post(`/mess/attendance/monthly-calendar`, data);
};

export const messAttendanceMonthlyReport = async (data) => {
  return await api.post(`/mess/attendance/monthly-report`, data);
};
